export const cleanWhitespaces = (string) => {
  return string.replace(/\s+/g, ' ')
}

export const cleanAccents = (string) => {
  return string.normalize('NFD').replace(/\p{Diacritic}/gu, '')
}
